import React from 'react';
import TransactionList from 'components/transactionList/TransactionList';

const Transactions = () => {
  return (
    <TransactionList title="All Accounts"/>
  )
}

export default Transactions